import { isUndefined } from './isDefined';

export default function searchNumbers(value, searchTerm) {
  if (isUndefined(value)) {
    return false;
  }

  const valueStr = value.toString().replace(/ |\+|\s/g, '');

  if (searchTerm.startsWith('%')) {
    const cleanSearchTerm = searchTerm.replace(/ |\s/g, '');
    const searchValue = cleanSearchTerm.substring(1);
    return valueStr.endsWith(searchValue);
  }

  if (searchTerm.startsWith('+')) {
    const cleanSearchTerm = searchTerm.replace(/ |\s/g, '');
    const searchValue = cleanSearchTerm.substring(1);
    return valueStr.startsWith(searchValue);
  }

  const cleanSearchTerm = searchTerm.replace(/ |\+|\s/g, '');

  if (searchTerm.endsWith('%')) {
    const searchValue = cleanSearchTerm.substring(
      0,
      cleanSearchTerm.length - 1
    );
    return valueStr.startsWith(searchValue);
  }

  return valueStr.indexOf(cleanSearchTerm) !== -1;
}
